<div class="container text-center pb-5">
  <div class="d-inline-block song-wrapper">
    <h2 *ngIf="initSongTitle == song?.title" class="h4">Dagens bordvers</h2>
    <p *ngIf="song?.melody"><i>{{ song.melody }}</i></p>
    <div [innerHtml]="song?.text" class="song-container"></div>
    <p *ngIf="song?.credits">{{ song.credits }}</p>
    <hr class="my-4">
    <button (click)="onClickGetRandomSong()" class="btn btn-primary">Skift sang <i class="fas fa-sync ml-2"></i></button>
    <a routerLink="/alle-vers" class="d-block mt-5">Se flere bordvers</a>
  </div>
</div>